import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { LoginTokenBody } from './login';

const LOG_IN_TOKEN_API_URL = '/api/v2/auth/login-token';

@Injectable()
export class LoginService {
  constructor(public http: HttpClient) {}

  getLogInToken(body: LoginTokenBody) {
    return this.http.post(LOG_IN_TOKEN_API_URL, body);
  }
}
